// extracted by mini-css-extract-plugin
export default {"rating":"kQ-z","numberOfStars":"lQ-z","count":"mQ-z","barGraphSpacing":"nQ-z","barGraph":"oQ-z"};